<section class="section" #screen>
    <div class="shell shell--size-3">
        <br />
        <div class="row chart">
            <div class="col" *ngIf="!newsletter">
                <!-- <div class="chart__head hidden-xs"> -->
                <div class="chart__head">
                    <div class="chart__head-content">
                        <h6>eToro Analysis</h6>

                        <h5>Cosmic Algorithm Ltd.</h5>

                        <span>{{DynamUpd}}</span><br />
                        <!-- <span>Last Updated: {{updateRecent}}</span> -->
                    </div><!-- /.chart__head-content -->

                </div><!-- /.chart__head -->
            </div>
            <div *ngIf="!mobile" class="col legendGrad legendShadow" id="legend">
                <div id="legendItems">
                    <div class="row" style="margin-bottom: 10px;">
                        <div class="col">AGR - 2021 (Traded Gain)</div>
                        <div class="col"><span id="tGain"><span *ngIf="gPos">+</span>{{tGain}}%</span></div>
                    </div>
                    <div class="row" style="margin-bottom: 10px;">
                        <div class="col">AGR - Since Launch</div>
                        <div class="col"><span id="tLaunch"><span *ngIf="lPos">+</span>{{tLaunch}}%</span></div>
                    </div>
                    <div class="row" style="margin-bottom: 10px;">
                        <div class="col">NSDQ100 Index</div>
                        <div class="col"><span id="tNSDQ"><span *ngIf="nPos">+</span>{{nsdqVal}}%</span></div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="mobile" class="row legendGrad legendShadow" id="legend">
            <div id="legendItems">
                <div class="row" style="margin-bottom: 10px;">
                    <div class="col">AGR - 2021 (Traded Gain)</div>
                    <div class="col-auto" style="padding-right: 1rem;"><span id="tGain"><span *ngIf="gPos">+</span>{{tGain}}%</span> </div>
                </div>
                <div class="row" style="margin-bottom: 10px;">
                    <div class="col">AGR - Since Launch</div>
                    <div class="col-auto" style="padding-right: 1rem;"><span id="tLaunch"><span *ngIf="lPos">+</span>{{tLaunch}}%</span></div>
                </div>
                <div class="row" style="margin-bottom: 10px;">
                    <div class="col">NSDQ100 Index</div>
                    <div class="col-auto" style="padding-right: 1rem;"><span id="tNSDQ"><span *ngIf="nPos">+</span>{{nsdqVal}}%</span></div>
                </div>
            </div>
        </div>
        <br />
        <div class="row chart">
            <div class="chart__body" class="wow fadeInRight" data-wow-delay=".5s" id="chart">
                <div id="container" style="text-align:center;">
                </div><!-- /.chart__body -->
            </div>
        </div>
    </div><!-- /.shell -->
</section>